import { render, staticRenderFns } from "./ResourceSearchs.vue?vue&type=template&id=71dda4f9&"
import script from "./ResourceSearchs.vue?vue&type=script&lang=js&"
export * from "./ResourceSearchs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports